exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".printHeader {\n  display: none;\n  padding-bottom: 45px; }\n\n.print-left-col {\n  text-align: left; }\n\n.print-middle-col {\n  text-align: center; }\n\n.print-right-col {\n  text-align: right; }\n\n.print-herb {\n  max-width: 30px;\n  max-height: 40px; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/PrintHeader/PrintHeader.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB,EAAE;;AAEzB;EACE,iBAAiB,EAAE;;AAErB;EACE,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,iBAAiB,EAAE","file":"PrintHeader.scss","sourcesContent":[".printHeader {\n  display: none;\n  padding-bottom: 45px; }\n\n.print-left-col {\n  text-align: left; }\n\n.print-middle-col {\n  text-align: center; }\n\n.print-right-col {\n  text-align: right; }\n\n.print-herb {\n  max-width: 30px;\n  max-height: 40px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/PrintHeader/PrintHeader.scss
// module id = 2389
// module chunks = 0